export const removeObjectArray = (array: Array<any>) => {
  for (let i = array.length - 1; i > -1; i--) {
    const arrValues = Object.values(array[i]);
    if (arrValues.filter(Boolean).length === 0) {
      array.splice(i, 1);
    }
  }
  return array;
};
